export const getDateRange = (date, dateTo) => {
	const [, startMonth, startDay] = date.split('-')
	const [, endMonth, endDay] = dateTo.split('-')
	const range = (startMonth !== endMonth)
		? `${ startDay }.${ startMonth }-${ endDay }.${ endMonth }`
		: `${ startDay }-${ endDay }.${ endMonth }`
	return range
}

export const getYear = (date, dateTo) => {
	const [startYear] = date.split('-')
	const [endYear] = dateTo.split('-')
	const year = (startYear !== endYear)
		? `${ startYear }-${ endYear }`
		: startYear
	return year
}



// WEBPACK FOOTER //
// ./src/assets/js/date.js